import React, { useState, useEffect } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import MaterialDataGrid from '../../components/MaterialDataGrid'
import MaterialTypography from '../../components/MaterialTypography'
import { Card, CardHeader, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import MaterialButton from '../../components/MaterialButton'
import AddIcon from '@mui/icons-material/Add';
import BASEURL from '../Utils/Baseurl';
import axios from 'axios';
import {useUserDetails} from '../../context/auth'
const SalaryStructure = () => {

    const navigate = useNavigate()
    const { salaryview,setsalaryview,salaryedit,setsalaryedit,setviewcomponent,AccessData} = useUserDetails()
    const [pageState, setPageState] = useState({
        loading: false,
        error: false,
        message: "",
        state: 'init'
    })

    const [data, setData] = useState([]);
    const [salaryStructureList, setSalaryStructureList] = useState([])

    useEffect(() => {
        onSalaryStructureSubmit();
    }, []);

    const SalaryStructureListTable = {
        columns: [
            {
                field: "structureName",
                headerName: "Structure Name",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "salaryType",
                headerName: "Salary Type",
                flex: 1,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
        ],
        rows: salaryStructureList
    }

    const handleNewSalaryStructure = () => {
        navigate('/salary-structure/add-salary-structure')
        setsalaryview(false)
        setsalaryedit(false)
        setviewcomponent(false)
    }

    const onEmployeeListClick = (e) => {
        console.log('onEmployeeListClick:', e?.id, e)
        setsalaryview(true)
        setsalaryedit(true)
        setviewcomponent(true)
        if (e?.id) {
           
            navigate(`/salary-structure/add-salary-structure?id=${e?.id}`)
        }
    }


    const onSalaryStructureSubmit = async () => {
        const query = `
         query allsalarystructure{
  salaryStructures {
    id
    structureName
    salaryType
    components {
      id
      percentage
      amount
      type
      calculatedFrom
      }
    }
  }


        `;

        try {
            setPageState({ ...pageState, loading: true });

            const response = await axios.post(BASEURL, {
                query: query
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            console.log("response:",response.data);
            

            // Extract Employee data from the response
            const salaryStructureList = response.data.data.salaryStructures;
            const uniqueStructures = salaryStructureList
                .filter((item, index, self) =>
                    index === self.findIndex(
                        (obj) =>
                            obj.structureName === item.structureName &&
                            obj.salaryType === item.salaryType &&
                            obj.payrollFrequency === item.payrollFrequency
                    )
                )
                .map((item) => ({
                    id: item.id,
                    structureName: item.structureName,
                    salaryType: item.salaryType,
                    payrollFrequency: item.payrollFrequency,
                }));
            setData(salaryStructureList);
            setSalaryStructureList(uniqueStructures);
            setPageState({ ...pageState, loading: false, state: 'success' });
        } catch (error) {
            console.error('ResponseError:', error);
            setPageState({ ...pageState, loading: false, error: true, message: error.message });
        }
    };

    return (
        <DashboardLayout>
            <Card >
                <CardHeader title={(
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                Salary Structure list
                            </MaterialTypography>
                            {/* <MaterialTypography variant="caption" color="text">
                                List of salary structure that you can get details of salary structure.
                            </MaterialTypography> */}
                        </Stack>
                        {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "AddSalaryStructure" && item.can_access
                ) && (
                        <MaterialButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={() => handleNewSalaryStructure()}
                        >
                            Salary Structure
                        </MaterialButton>
                )}
                    </Stack>


                )} />
                <MaterialDataGrid
                    customHeight={550}
                    rows={salaryStructureList}
                    columns={SalaryStructureListTable.columns}
                    checkboxSelection={false}
                    isSelectable={false}
                    onRowClick={onEmployeeListClick}
                    loading={pageState.loading}
                    localeText={{
                        noRowsLabel: (
                            <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                                <MaterialTypography variant="body2" fontWeight="medium" color="text">
                                    No salary structure found
                                </MaterialTypography>
                                <MaterialTypography variant="caption" color="text">
                                    You have not yet add any salary structure details. Click on the "Add Salary Structure" button to start adding salary structure details.
                                </MaterialTypography>
                            </Stack>
                        )
                    }}
                />
            </Card>
        </DashboardLayout>
    )
}

export default SalaryStructure
